import { Injectable } from '@angular/core';
import {
  CanActivate, ActivatedRouteSnapshot, Router, CanLoad, CanActivateChild, Route,
  RouterStateSnapshot
} from '@angular/router';

import { LoginService } from '../../services/login.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
    private loginService: LoginService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let url: string = state.url;

    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    let url = `/${route.path}`;

    return this.checkLogin(url);
  }

  checkLogin(url: string): boolean {
    if (this.loginService.isLogged()) {
      return true;
    }

    // Store the attempted URL for redirecting
    this.loginService.setRedirectUrl(url);

    // Navigate to the login page
    this.router.navigate(['/portal']).then();
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/auth-guard.ts